videojs.addLanguage('en', {
	'Game': 'Game'
});

